// extracted by mini-css-extract-plugin
export var chevronIcon = "_ab-2";
export var teamName = "_ab-1";
export var teamSwitcherButton = "_ab-0";